





































import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 * API
 */
import { AccountResponseModel } from '@/api/accounts';

/**
 * Composant de visualisation simple d'un compte sous forme de carte.
 */
@Component
export default class AccountCard extends Vue {
	/** Propriétés */
	@Prop() account!: AccountResponseModel;
	@Prop({ default: false }) disableCollectiveAccount!: boolean;
	@Prop() onCreditButtonClick!: (id: number) => void;
	@Prop({ default: false }) enableAccountCredit!: boolean;
	@Prop({ default: false }) isLoading!: boolean;

	/** Méthodes */
	handleOpenCreditDialog(id: number) {
		this.onCreditButtonClick(id);
	}

	isAccountCollective() {
		return this.account.isCollective;
	}
}
